module.exports = __webpack_public_path__ + "img/clean-b.0070c5bd.svg";